import { Partner } from "../Stores/PartnerStore";
import Assessment, { IAssessmentSnapshotIn } from "./Assessment";

export const MedicalAssessmentQuestionsSnapshot = [
  {
    key: "MedicalDomainTask1",
    timeToComplete: null,
    question:
      "Have you completed a comprehensive geriatric assessment with a geriatric physician or primary care physician?",
    answer: "",
    taskName: "Geriatric Assessment",
  },
  {
    key: "MedicalDomainTask2",
    timeToComplete: null,
    question:
      "It is important to understand your loved one's medical conditions and how to monitor and respond to changes in their health and functional status.  Do you understand how to do this?",
    answer: "",
    taskName: "Monitoring Changes",
  },
  {
    key: "MedicalDomainTask3",
    timeToComplete: null,
    question:
      "It is important to know who your loved one's health care providers are and to become an active member of their health care team. Have you discussed this with your loved one?",
    answer: "",
    taskName: "Healthcare Team",
  },
  {
    key: "MedicalDomainTask4",
    timeToComplete: null,
    question:
      "It is important to create a medication list with all your loved one's medications and to keep it up to date. Have you done this?",
    answer: "",
    taskName: "Medication Management",
  },
  {
    key: "MedicalDomainTask5",
    timeToComplete: null,
    question:
      "Have you developed a plan with the older adult to evaluate their driving skills on a regular basis?",
    answer: "",
    taskName: "Evaluate Driving Skills",
  },
  {
    key: "MedicalDomainTask6",
    timeToComplete: null,
    question:
      "Have you met with a geriatric care manager to create or update the older adult's plan of care?",
    answer: "",
    taskName: "Geriatric Care Manager",
  },
  {
    key: "MedicalDomainTask7",
    timeToComplete: null,
    question:
      "Have you assessed the quality and appropriateness of care in retirement and healthcare facilities (e.g., nursing homes, assisted-living facilities, dementia-care units, aging-in-place facilities) in the older adult's community?",
    answer: "",
    taskName: "Assess Facility Quality",
  },
  {
    key: "MedicalDomainTask8",
    timeToComplete: null,
    question:
      "Have you, after consultation with your parent's physician, worked with the older adult to develop a plan of physical exercise and activities appropriate to their health and interests?",
    answer: "",
    taskName: "Exercise and Activity Plan",
  },
  {
    key: "MedicalDomainTask9",
    timeToComplete: null,
    question:
      "Have you learned how to identify possible signs of cognitive impairment in the older adult and, if so, sought neurological consultation?",
    answer: "",
    taskName: "Cognitive Impairment",
  },
  //updated task data 1-9
  {
    key: "MedicalDomainTask10",
    timeToComplete: null,
    question:
      "Have you talked to your loved one and decided when a dementia screening should be scheduled?",
    answer: "",
    taskName: "Specialized Care",
  },
  {
    key: "MedicalDomainTask11",
    timeToComplete: null,
    question:
      "Have you talked to your loved one and decided when a dementia screening should be scheduled?",
    answer: "",
    taskName: "Community Services",
  },
  {
    key: "MedicalDomainTask12",
    timeToComplete: null,
    question:
      "Have you talked to your loved one and decided when a dementia screening should be scheduled?",
    answer: "",
    taskName: "Dementia Screening",
  },
];

export const DummyPartner = Partner.create({
  partnerId: "1",
  backgroundColor: "",
  navigationBarColor: "",
  fontColor: "",
});

export const MedicalAssessmentSnapshot: IAssessmentSnapshotIn = {
  id: "Medical",
  questions: MedicalAssessmentQuestionsSnapshot,
  infoSlideKeys: [
    "MedicalDomainTask1",
    "MedicalDomainTask2",
    "MedicalDomainTask3",
    "MedicalDomainTask4",
    "MedicalDomainTask5",
    "MedicalDomainTask6",
    "MedicalDomainTask7",
    "MedicalDomainTask8",
    "MedicalDomainTask9",
    "MedicalDomainTask10",
    "MedicalDomainTask11",
    "MedicalDomainTask12",
  ],
};

export const DefaultMedicalAssessment = Assessment.create(
  MedicalAssessmentSnapshot
);
